import { render } from "./ProductListItem.vue?vue&type=template&id=56c3e8ec&scoped=true"
import script from "./ProductListItem.vue?vue&type=script&lang=js"
export * from "./ProductListItem.vue?vue&type=script&lang=js"

import "./ProductListItem.vue?vue&type=style&index=0&id=56c3e8ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c3e8ec"]])

export default __exports__